import InfoIcon from '@mui/icons-material/Info';
import { Alert, Link, Stack, Typography } from '@mui/material';
import { useCallback, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { WizardPage } from '../../../../general/components/wizard-page';
import { ProgressButton } from '../../../../general/inputs/progress-button';
import { nextStep, selectnextStep } from '../../reducers/next-step';

const CreditLockedPage: FC = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector(selectnextStep);
  const retryApplication = useCallback(() => {
    dispatch(
      nextStep({
        action: 'unlock_consumer_credit',
        gotoNextPage: true,
      }),
    );
  }, [dispatch]);
  return (
    <WizardPage
      title={
        <>
          We need you to remove the
          <br />
          lock on your credit file.
        </>
      }
      footer={<YouCanComeBackNote />}
    >
      <Stack spacing={5}>
        <Typography variant="inherit" component="p" align="center" color="textSecondary">
          We are unable to proceed with your application because there is a lock or freeze on your personal credit file.
        </Typography>
        <Typography variant="inherit" component="p" align="center" color="textSecondary">
          To unlock your file, you can call Transunion at
          <br />
          <Link href="tel:+1-800-916-8800" color="primary">
            800-916-8800
          </Link>
          &nbsp;and choose option 4 to speak with a representative. Alternatively, you can unlock your file <br />
          online at&nbsp;
          <Link href="https://www.transunion.com" target="_blank">
            www.transunion.com
          </Link>
          .
        </Typography>
        <Typography variant="inherit" component="p" align="center" color="textSecondary">
          We use your credit file to help assess your creditworthiness and to help verify your identity.
        </Typography>
        <Alert icon={<InfoIcon color="success" />} severity="success" sx={{ alignItems: 'center' }}>
          Remember, applying for a Coast account will not affect your personal credit score.
        </Alert>
        <ProgressButton
          type="submit"
          color="primary"
          fullWidth
          progress={loading}
          size="large"
          sx={{ mt: 4 }}
          variant="contained"
          onClick={retryApplication}
        >
          Lock removed, try again
        </ProgressButton>
      </Stack>
    </WizardPage>
  );
};

export { CreditLockedPage };
